import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-password-strength-meter',
  templateUrl: './password-strength-meter.component.html',
  styleUrls: ['./password-strength-meter.component.scss']
})
export class PasswordStrengthMeterComponent {
  @Input() passwordControl!: UntypedFormControl;
  @Input() score!: number;
  @Input() toggleErrorColor: boolean = false;
  @Input() isAddMargin: boolean = false;

  get password(): string {
    return this.passwordControl?.value ? this.passwordControl.value : '';
  }

  get charactersLabel(): string {
    return this.passwordControl?.value?.length !== 1 ? 'characters' : 'character';
  }
}
